import { DEFAULT_SETTINGS_FOR_EARNINGS_DATA } from '../earnings-common/constants'
import { EarningsEstimateType, EarningsSettings, EarningsTimeframeEnum } from '../earnings-common/types'

export const EARNINGS_DATE_FORMAT = 'MMM dd, yyy'

export const PRICE_REVISIONS_CHART_HEIGHT = 296
export const PRICE_REVISIONS_YAXIS_WIDTH = 40
export const PRICE_REVISIONS_TICK_COUNT = 6

export const UPDOWN_REVISIONS_CHART_HEIGHT = 135
export const UPDOWN_REVISIONS_TICK_COUNT = 7

export const FISCAL_YEAR_MARK = 'FY'

export const SETTINGS_COOKIE_KEY = 'earningsSettings'

export const DEFAULT_SETTINGS: EarningsSettings = {
  ...DEFAULT_SETTINGS_FOR_EARNINGS_DATA,
  estimateType: EarningsEstimateType.eps,
  fiscalPeriod: '',
  timeframe: EarningsTimeframeEnum.quarterly,
}
